import { site } from '../../../mocks/entertainment';

const cols = [
  { title: '精华栏目', links: [['本周热榜', '#weekly'], ['年度大瓜', '#annual'], ['名场面', '#moments'], ['深扒专题', '#features']] },
  { title: '关于本站', links: [['常见问题', '#faq'], ['关于我们', '#about'], ['订阅追更', '#subscribe'], ['顶部返回', '#top']] },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-lg text-background-950">
                <i className="ri-flashlight-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.brand}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/70">
              {site.slogan} · {site.tagline}。每周热门事件汇总、年度大瓜回顾、明星名场面合集，
              用最精炼的方式带你回顾娱乐圈的高光与争议时刻，收藏这一篇就够了。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-bilibili-fill', 'ri-douban-fill'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-background-50/15 text-base text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-400"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <nav key={c.title} aria-label={c.title}>
              <h3 className="text-sm font-bold text-background-50">{c.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {c.links.map(([label, href]) => (
                  <li key={href}>
                    <a
                      href={href}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-background-100/70 transition-colors hover:text-accent-400"
                    >
                      <i className="ri-arrow-right-s-line text-accent-400/70" aria-hidden="true"></i>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 border-t border-background-50/10 pt-6 text-center md:text-left">
          <p className="text-xs leading-relaxed text-background-100/55">
            本站内容为对公开讨论信息的观点化盘点与整理，含戏谑成分，仅用于信息交流，不代表官方立场，
            不对任何个人作不负责任的价值定论。文中人物均为内容创作所拟的虚构舞台名，如有雷同纯属巧合。
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/55">
            © {new Date().getFullYear()} {site.brand} · 保留所有权利
          </p>
          <a
            href={`mailto:${site.email}`}
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-background-100/70 transition-colors hover:text-accent-400"
          >
            <i className="ri-mail-line" aria-hidden="true"></i>
            {site.email}
          </a>
        </div>
      </div>
    </footer>
  );
}